// src/hooks/useLogin.js

import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {login} from "../config/apiRoutes";
import {authService} from "../services/authService";

export const useLogin = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [formData, setFormData] = useState({
        user_name: '',
        password: ''
    });

    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [serverError, setServerError] = useState('');

    const from = location.state?.from?.pathname || '/dashboard';

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));

        // پاک کردن خطای فیلد هنگام تایپ
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: '' }));
        }
        if (serverError) {
            setServerError('');
        }
    };

    const validateForm = () => {
        const newErrors = {};

        // اضافه کردن ولیدیشن برای نام کاربری (در صورت نیاز)
        if (!formData.user_name) {
            newErrors.user_name = 'نام کاربری الزامی است';
        }

        if (!formData.password) {
            newErrors.password = 'رمز عبور الزامی است';
        } else if (formData.password.length < 6) {
            newErrors.password = 'رمز عبور باید حداقل ۶ کاراکتر باشد';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        setIsLoading(true);
        setServerError('');

        try {

            await authService.login(formData.user_name, formData.password);
            navigate(from, { replace: true });

        } catch (error) {
            console.log(error);
            setServerError(error.data.message || 'خطا در ورود به سیستم');
        } finally {
            setIsLoading(false);
        }
    };

    return {
        formData,
        errors,
        isLoading,
        showPassword,
        serverError,
        setShowPassword,
        handleChange,
        handleSubmit
    };
};